'use client';

import { useEffect } from 'react';
import { useUserResourceSource } from '@akademi/site-builder-runtime';

/**
 * Fire-and-forget client component that marks a video as "watched"
 * in the user's history on mount. Renders nothing.
 *
 * <p>Guards against React 18 strict-mode double-effect by deduping
 * per-videoSlug at the module level.
 */
const sent = new Set<string>();

export interface HistoryWriterProps {
  videoSlug: string;
}

export function HistoryWriter({ videoSlug }: HistoryWriterProps) {
  const ur = useUserResourceSource();
  useEffect(() => {
    if (!ur?.history) return;
    if (sent.has(videoSlug)) return;
    sent.add(videoSlug);
    void ur.history.mark({ videoSlug });
  }, [ur, videoSlug]);
  return null;
}
